import React from "react";
import { Button } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import styles from "../styles.module.scss";

export default function CustomBtn({
  title,
  type = "primary", // primary | secondary | danger | text
  icon,
  onClick,
  loading = false,
  disabled = false,
  fullWidth = false,
}) {
  const classNames = [
    styles.btn,
    styles[type],
    fullWidth ? styles.fullWidth : "",
  ].join(" ");

  return (
    <Button
      className={classNames}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? (
        <LoadingOutlined style={{ marginRight: 6 }} />
      ) : (
        icon && <span className={styles.icon}>{icon}</span>
      )}
      {title}
    </Button>
  );
}
